// extracted by css-extract-rspack-plugin
export default {"CopyButton":"UN3cw","InfoIcon":"ZRWvY"};